export enum RewardsBeneficiariesEnum {
    Organization = 1,
    Location = 2,
    User = 3
}
